// extracted by mini-css-extract-plugin
export default {"timeline-item":"DealHistoryRecord_timeline-item__8cgN6","timeline-items":"DealHistoryRecord_timeline-items__q8GRz"};